import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Manufacturing from "./pages/Manufacturing";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import CardView from "./pages/CardView";
import Team from "./pages/Team";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

const Admin = lazy(() => import("./pages/Admin"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/kiosks" element={<Navigate to="/products?cat=kiosk&sub=ticket_redemption" replace />} />
          <Route path="/gameboards" element={<Navigate to="/products?cat=gameboard&sub=all" replace />} />
          <Route path="/arcade" element={<Navigate to="/products?cat=arcade&sub=coin_pusher" replace />} />
          <Route path="/gaming-systems" element={<Navigate to="/products?cat=gaming_system" replace />} />
          <Route path="/manufacturing" element={<Manufacturing />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<Suspense fallback={<div className="min-h-screen bg-[#050505]" />}><Admin /></Suspense>} />
          <Route path="/card/:slug" element={<CardView />} />
          <Route path="/team" element={<Team />} />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
